import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { NOTIFICATION_COUNTS_KEY } from '@/lib/query-client';
import { appointmentKeys, calendarKeys } from '@/features/calendar/api';
import { onlineBookingApi, onlineBookingKeys } from './api';

export function useFeatureEnabled(feature: 'onlineBooking') {
  return useQuery({
    queryKey: ['settings', 'features'],
    queryFn: () => api.get<{ onlineBooking: boolean; responseThresholdMinutes?: number }>('/settings/features').then((r) => r.data),
    staleTime: 60_000,
    retry: false,
  });
}

export function useOnlineBookingCounts(enabled: boolean) {
  return useQuery({
    queryKey: onlineBookingKeys.counts,
    queryFn: onlineBookingApi.counts,
    enabled,
    refetchInterval: 60_000,
    staleTime: 55_000,
    retry: false,
  });
}

export function useInvalidateBookingQueries() {
  const qc = useQueryClient();
  return () => {
    void qc.invalidateQueries({ queryKey: onlineBookingKeys.all });
    void qc.invalidateQueries({ queryKey: NOTIFICATION_COUNTS_KEY });
    void qc.invalidateQueries({ queryKey: calendarKeys.all });
    void qc.invalidateQueries({ queryKey: appointmentKeys.all });
  };
}
